import React from 'react';
import FooterContainer from './footer.styles';
import Container from './../container/container.component';
const Footer = () => {
    return (
        <FooterContainer>
            <Container>
                <div className="container">
                    <img src="https://i.ibb.co/1KcQ7gw/logo.png" alt="Logo" />
                    <p>We Are Social</p>
                    <div className="social-icons">
                        <a
                            href="https://www.facebook.com/moutaz.abdalbaky"
                            target="_blank"
                        >
                            <i className="fab fa-facebook-f" />
                        </a>
                        <a
                            href="https://github.com/MoatazAbdElbaky"
                            target="_blank"
                        >
                            <i className="fab fa-github" />
                        </a>
                        <a href="#Landing">
                            <i className="fas fa-home" />
                        </a>
                        <a
                            href="https://www.linkedin.com/in/moataz-abdalbaky-54834922b/"
                            target="_blank"
                        >
                            <i className="fab fa-linkedin" />
                        </a>
                    </div>
                    <p className="copyright">
                        &copy; 2021 <span>Kasper</span> All Right Reserved
                    </p>
                </div>
            </Container>
        </FooterContainer>
    );
};
export default Footer;
